export type PauseScene = 'play' | 'editor' | 'boats';

export type PauseAction = 'resume' | 'restart' | 'editor' | 'boats' | 'main';

export type PauseItem = {
  action: PauseAction;
  label: string;
};

export type PauseMenuOptions = {
  /** GameScene stage is `racing`. Placement, aiming, a finish, and replay omit it. */
  racing?: boolean;
};

const ITEMS: readonly PauseItem[] = [
  { action: 'resume', label: 'Resume' },
  { action: 'restart', label: 'Restart Race' },
  { action: 'editor', label: 'Editor' },
  { action: 'boats', label: 'Boats' },
  { action: 'main', label: 'Main menu' },
];

/**
 * Resume first, Main menu last. The scene you are already in is omitted.
 * Restart Race is only offered from play while a race is underway.
 */
export function pauseMenuItems(
  scene: PauseScene,
  options: PauseMenuOptions = {},
): PauseItem[] {
  return ITEMS.filter((item) => {
    if (item.action === 'restart' && (scene !== 'play' || !options.racing)) {
      return false;
    }

    if (scene === 'editor' && item.action === 'editor') {
      return false;
    }

    if (scene === 'boats' && item.action === 'boats') {
      return false;
    }

    return true;
  });
}
